// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

// interfaces/types
import { type DashMiddleware, type DashStore, type DashNext, dealerSelectors } from '@makemydeal/dr-shared-store';
import { SOCKET_EVENT_IGNORED, SOCKET_EVENT_RECEIVED } from '../actionTypes/socketActionTypes';
import { updateDealRefId } from '../actions/offerActionCreators';
import * as offerSelectors from '../selectors/offerSelectors';
import { CREDIT_APP_SEARCH_MERGE_DEAL } from '../actionTypes/creditAppSearchActionTypes';

export const dealRefIdMiddleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    const prevState = store.getState();
    next(action);
    const state = store.getState();
    switch (action.type) {
        case CREDIT_APP_SEARCH_MERGE_DEAL:
            if (dealerSelectors.getEnableGenerateContracts(state)) {
                (window as any).drSocketManager.refresh();
            }
            break;
        case SOCKET_EVENT_RECEIVED:
        case SOCKET_EVENT_IGNORED: {
            const event = action.payload;
            const dealRefId = event.data?.coxAutoReferences?.dealRefId;
            const prevDealRefId = offerSelectors.getDealRefId(prevState);
            if (
                dealRefId &&
                prevDealRefId !== dealRefId &&
                event.topic === 'dealXgPatch' &&
                !event.message?.includes('subscribe')
            ) {
                store.dispatch(updateDealRefId({ dealRefId }));
            }
            if (dealerSelectors.getEnableGenerateContracts(state)) {
                if (dealRefId && prevDealRefId !== dealRefId) {
                    (window as any).drSocketManager.refresh();
                }
            }
            break;
        }
    }
};
